// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 445 ? "start" : chunkId) + "." + {"445":"68b4c774","632":"68b4c774","794":"4cc32d8f","976":"b3962628"}[chunkId] + ".chunk.css";
};